"use client";

import { FC, useEffect, useState } from "react";
import { captureException } from "@sentry/react";
import { GenerateNpcForm } from "components/molecules/GenerateNpcForm";
import { getFields, getThemes } from "lib/actions";
import { IPromptOptions } from "types";
import * as Styled from "./NpcLanding.styled";
export const NpcLanding: FC = () => {
  const [fields, setFields] = useState<{
    [key: string]: string[];
  }>({});
  const [prompts, setPrompts] = useState<IPromptOptions[]>([]);
  useEffect(() => {
    (async () => {
      try {
        const npcFields = await getFields();
        if (npcFields.fields && npcFields.fields.npcFieldsMap) {
          setFields(npcFields.fields.npcFieldsMap);
        }
      } catch (error: any) {
        captureException("Failed to fetch fields:", error);
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      const {
        themes
      } = await getThemes();
      setPrompts(themes);
    })();
  }, []);
  return <Styled.Main data-sentry-element="unknown" data-sentry-component="NpcLanding" data-sentry-source-file="index.tsx">
            <GenerateNpcForm fieldOptions={fields} prompts={prompts} data-sentry-element="GenerateNpcForm" data-sentry-source-file="index.tsx" />
        </Styled.Main>;
};